import { IconDotsVertical, IconDownload, IconEdit, IconTrash } from '@tabler/icons-react';
import NSIcon from 'bricks/NSIcon/NSIcon';
import { NSButton } from 'bricks';
import React, { useState } from 'react';
import {
    Dropdown, DropdownToggle,
    DropdownItem,
    DropdownMenu,
} from 'reactstrap';

interface IDocumentActionOptionsProps {
    onDownload: () => void;
    isFile: boolean;
    onDelete: any
    onEdit: (e: React.MouseEvent) => void;
}

const DocumentActionOptions = ({
    onDownload, isFile, onDelete, onEdit,
}: IDocumentActionOptionsProps) => {
    const [openOptions, setOpenOptions] = useState(false);

    return (
        <Dropdown className="FileTileCard__dropdown" isOpen={openOptions} toggle={() => setOpenOptions(!openOptions)} direction="down">
            <DropdownToggle tag="button" className="FileTileCard__dropdown-toggle mt-1">
                <NSButton color="secondary-lighten" icon={IconDotsVertical} />
            </DropdownToggle>
            <DropdownMenu>
                {isFile && (
                    <DropdownItem onClick={onDownload} data-testid="download-action" className="text-white">
                        <div className="d-flex align-items-center justify-content-between w-100">
                            <span>Download</span>
                            <NSIcon icon={IconDownload} />
                        </div>
                    </DropdownItem>
                )}
                <DropdownItem onClick={onEdit} data-testid="edit-action" className="text-white">
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <span>Edit</span>
                        <NSIcon icon={IconEdit} />
                    </div>
                </DropdownItem>
                <DropdownItem onClick={onDelete} data-testid="delete-action" className="text-white">
                    <div className="d-flex align-items-center justify-content-between w-100">
                        <span>Delete</span>
                        <NSIcon icon={IconTrash} />
                    </div>
                </DropdownItem>
            </DropdownMenu>
        </Dropdown>
    );
};

export default DocumentActionOptions;
